var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.398 11.68a.603.603 0 0 1-.082-.006 50.674 50.674 0 0 0-6.715-.494c.034 5.866.034 8.83 0 8.891-.27 1.08-1.283 1.893-2.392 1.893-1.32 0-2.393-1.131-2.393-2.52 0-.35.269-.634.602-.634.333 0 .602.283.602.634 0 .69.534 1.252 1.189 1.252.656 0 1.188-.562 1.188-1.252v-8.258c-2.219.03-4.461.179-6.717.488a.59.59 0 0 1-.475-.153.645.645 0 0 1-.205-.476c0-4.253 3.013-7.77 6.908-8.335C11.12 2.294 11.521 2 12 2c.48 0 .883.294 1.093.71C16.987 3.274 20 6.793 20 11.045a.652.652 0 0 1-.206.479.586.586 0 0 1-.396.155zm-3.986 5.842c.532-.56 1.766-.507 2.04.566a1.21 1.21 0 0 1 2.037-.566c.68.715.68 1.879.001 2.595l-1.613 1.698a.585.585 0 0 1-.852 0l-1.613-1.698a1.878 1.878 0 0 1-.51-1.298c0-.491.181-.951.51-1.297z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.cc93b53267c3eea210ccd710dd29696d.svg";
export { ForwardRef as ReactComponent };